"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoreChart = void 0;
var vue_1 = require("vue");
var chart_js_1 = require("chart.js");
var Color_1 = require("../Color");
chart_js_1.Chart.register.apply(chart_js_1.Chart, chart_js_1.registerables);
chart_js_1.Chart.defaults.font.size = 20;
chart_js_1.Chart.defaults.color = 'rgb(240, 240, 240)';
var ColorStringMap = new Map([
    [Color_1.Color.RED, 'rgb(153, 17, 0)'],
    [Color_1.Color.YELLOW, 'rgb(170, 170, 0)'],
    [Color_1.Color.GREEN, 'rgb(0, 153, 0)'],
    [Color_1.Color.BLACK, 'rgb(170, 170, 170)'],
    [Color_1.Color.BLUE, 'rgb(0, 102, 255)'],
    [Color_1.Color.PURPLE, 'rgb(140, 0, 255)'],
    [Color_1.Color.ORANGE, 'rgb(236, 113, 12)'],
    [Color_1.Color.PINK, 'rgb(245, 116, 187)'],
]);
exports.ScoreChart = vue_1.default.component('score-chart', {
    data: function () {
        return {};
    },
    props: {
        players: {
            type: Array,
        },
        generation: {
            type: Number,
        },
        animation: {
            type: Boolean,
        },
    },
    methods: {
        getLabels: function () {
            return Array.from({ length: this.generation }, function (_, index) { return index + 1; });
        },
        getOnePlayerDataSet: function (player) {
            return {
                label: player.name,
                data: player.endGenerationScores,
                fill: false,
                backgroundColor: ColorStringMap.get(player.color),
                borderColor: ColorStringMap.get(player.color),
                tension: 0.1,
                pointRadius: 6,
            };
        },
        getAllPlayerDataSet: function () {
            var _this = this;
            return this.players.map(function (player) { return _this.getOnePlayerDataSet(player); });
        },
        renderChart: function () {
            var ctx = document.getElementById('myChart');
            if (ctx !== null) {
                new chart_js_1.Chart(ctx, {
                    type: 'line',
                    data: {
                        labels: this.getLabels(),
                        datasets: this.getAllPlayerDataSet(),
                    },
                    options: {
                        animation: {
                            duration: this.animation ? 1000 : 0,
                            easing: 'linear',
                        },
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            y: {
                                title: { text: 'Victory Points', display: true },
                                beginAtZero: true,
                                grid: { color: 'rgb(90, 90, 90' },
                            },
                            x: {
                                title: { text: 'Generation', display: true },
                                offset: true,
                            },
                        },
                    },
                });
            }
        },
    },
    mounted: function () {
        this.renderChart();
    },
    template: "\n    <div class=\"score-chart-container\">\n      <div></div>\n        <canvas id=\"myChart\"></canvas>\n      <div></div>\n    </div>\n    ",
});
//# sourceMappingURL=ScoreChart.js.map